<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  data(){
    return {

    }
  }
}
</script>

<style lang="scss">
  html,body,#app{
    height: 100%;
    width: 100%;
    margin: 0px;
    padding: 0px;
  }
  @media screen and (max-width:1260px) {
    html{
      font-size: 10px;
    }
  }
  @media screen and (min-width:1260px) {
    html{
      font-size: 13px;
    }
  }
  @media screen and (min-width:1440px) {
    html{
      font-size: 14px;
    }
  }
   @media screen and (min-width:1560px) {
    html{
      font-size: 15px;
    }
  }
  @media screen and (min-width:1680px) {
    html{
      font-size: 16px;
    }
  }
</style>
